import { render, staticRenderFns } from "./ivm.vue?vue&type=template&id=e06b049e&"
import script from "./ivm.vue?vue&type=script&lang=js&"
export * from "./ivm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports